/* bezcizade – Ödeme butonu: checkout'a yalnızca sepette o an geçerli indirim kodlarıyla git.
   (FAST/EFT seçilip sonra vazgeçildiğinde FASTEFT3 kodunun ödeme sayfasına taşınmasını engeller.) */
(function(){
  var busy=false;
  document.addEventListener('click',function(e){
    var b=e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if(!b||busy) return;
    e.preventDefault(); e.stopPropagation(); busy=true;
    var note=document.querySelector('textarea[name="note"]');
    var p=note?fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:note.value})}):Promise.resolve();
    p.then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
     .then(function(cart){
        var codes=(cart.discount_codes||[]).filter(function(d){return d.applicable!==false;}).map(function(d){return d.code;}).join(',');
        window.location.href='/checkout?discount='+encodeURIComponent(codes);
     })
     .catch(function(){window.location.href='/checkout';});
  },true);
})();